import React from "react";
import HeroSection from "../components/HeroSection"; // Import HeroSection

export default function BackgroundPage() {
    return (
        <section className="background-page profil-section section">
            <div className="container">
                {/* Header */}
                <h2 className="section-title">Latar Belakang Perusahaan</h2>

                {/* Latar Belakang */}
                <p>
                    PT. Innovatech Digi Eravision lahir dari kolaborasi profesional dengan keahlian yang berbeda namun memiliki visi yang sama dalam menciptakan solusi inovatif. Berpengalaman di bidang IT, AV & Automation berkolaborasi dengan desain interior, sehingga memahami pentingnya estetika dalam menciptakan ruang yang nyaman dan fungsional.
                </p>
                <p>
                    Dengan sinergi tersebut akan membentuk fondasi perusahaan yang berfokus pada teknologi yang handal dan desain ruang yang estetik. Kami berkomitmen untuk memberikan solusi terbaik, baik dari sisi teknologi maupun desain.
                </p>
            </div>
        </section>
    );
}